import { render, staticRenderFns } from "./DivFilter.vue?vue&type=template&id=c4c927f4&"
import script from "./DivFilter.vue?vue&type=script&lang=js&"
export * from "./DivFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports